import React from 'react'

export default function PrivacyPage(){
    return(
        <div>
            {/* <div id='privacineprivacypolicy301'></div> */}
        </div>
      
    )
}